import { useState } from 'react';
import { StellantisQuoteRequestDTO } from 'src/api/models/StellantisDTO';
import { Storage } from 'aws-amplify';
import { useErrorToast } from 'src/hooks/useErrorToast';
import i18next from 'i18next';

type DownloadState = {
	id?: string | null;
	externalPdf: boolean;
	hmpPdf: boolean;
};

export function useStellantisQuoteAttachments() {
	const { showError } = useErrorToast();
	const [downloadState, setDownloadState] = useState<DownloadState>({
		id: null,
		externalPdf: false,
		hmpPdf: false,
	});

	const downloadExternalPdf = async (quote: StellantisQuoteRequestDTO) => {
		try {
			if (!quote.externalPdf?.key) return;
			setDownloadState((prev) => ({
				...prev,
				id: quote.id,
				externalPdf: true,
			}));

			const [_public, rest] = quote.externalPdf.key.split('public/');
			const key = rest ?? _public;
			const downloadLink: string = await Storage.get(key, {
				bucket: process.env.REACT_APP_AWS_STORAGE_BUCKET_STELLANTIS_DOCUMENTS,
			});
			window.open(downloadLink, '_blank');
		} catch (error) {
			showError(error, i18next.t('failed_to_download_file'));
		} finally {
			setDownloadState((prev) => ({ ...prev, id: null, externalPdf: false }));
		}
	};

	const downloadHmpPdf = async (quote: StellantisQuoteRequestDTO) => {
		try {
			if (!quote.hmpPdf?.key) return;
			setDownloadState((prev) => ({ ...prev, id: quote.id, hmpPdf: true }));

			const [_public, rest] = quote.hmpPdf.key.split('public/');
			const key = rest ?? _public;
			const downloadLink: string = await Storage.get(key, {
				bucket: process.env.REACT_APP_AWS_STORAGE_BUCKET_STELLANTIS_DOCUMENTS,
			});
			window.open(downloadLink, '_blank');
		} catch (error) {
			showError(error, i18next.t('failed_to_download_file'));
		} finally {
			setDownloadState((prev) => ({ ...prev, id: null, hmpPdf: false }));
		}
	};

	return {
		downloadState,
		downloadExternalPdf,
		downloadHmpPdf,
	};
}
